<lib-modal-layout [title]="'Submission Review'" [subtitle]="''">
    <br/>
    <lib-submission-review [guid]="data.id" [status]="data.status" [model]="viewSubmissionStore.submissionReview?.()!" (closeModal)="dialogRef.close()"></lib-submission-review>
</lib-modal-layout>